module.exports = __webpack_public_path__ + "img/Graph-5.b8f2285d.svg";